export default __webpack_public_path__ + "static/media/commissioningAndInspection.0b6cefc7.svg";